import bcrypt from 'bcryptjs'
import { createClient } from '@supabase/supabase-js'

const SESSION_KEY = 'ff_admin_session'

let _adminClient = null

export function getAdminSupabase() {
  if (_adminClient) return _adminClient
  const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL
  const SUPABASE_SERVICE_ROLE_KEY = process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY
  if (!SUPABASE_URL || !SUPABASE_SERVICE_ROLE_KEY) {
    throw new Error('Missing SUPABASE_SERVICE_ROLE_KEY - required for admin operations')
  }
  _adminClient = createClient(SUPABASE_URL, SUPABASE_SERVICE_ROLE_KEY, {
    global: { headers: { Authorization: `Bearer ${SUPABASE_SERVICE_ROLE_KEY}` } },
    auth: { autoRefreshToken: false, persistSession: false },
  })
  return _adminClient
}

export async function signIn(email, password) {
  const db = getAdminSupabase()
  const { data: users, error } = await db
    .from('admin_users')
    .select('id, name, email, password_hash')
    .eq('email', email.toLowerCase())
    .limit(1)

  if (error || !users || users.length === 0) {
    throw new Error('Credenciais inválidas')
  }

  const user = users[0]
  const valid = bcrypt.compareSync(password, user.password_hash)
  if (!valid) throw new Error('Credenciais inválidas')

  const token = crypto.randomUUID()
  await db.from('admin_users').update({ token }).eq('id', user.id)

  const session = { token, admin: { id: user.id, name: user.name, email: user.email } }
  localStorage.setItem(SESSION_KEY, JSON.stringify(session))
  return session
}

export async function signOut() {
  const session = getSession()
  if (session?.token) {
    try {
      const db = getAdminSupabase()
      await db.from('admin_users').update({ token: null }).eq('token', session.token)
    } catch {}
  }
  localStorage.removeItem(SESSION_KEY)
}

export function getSession() {
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export async function checkSession() {
  const session = getSession()
  if (!session?.token) return null

  try {
    const db = getAdminSupabase()
    const { data: users } = await db
      .from('admin_users')
      .select('id, name, email')
      .eq('token', session.token)
      .limit(1)

    if (!users || users.length === 0) {
      localStorage.removeItem(SESSION_KEY)
      return null
    }
    return { token: session.token, admin: users[0] }
  } catch {
    return null
  }
}
